import { Box, Stack, Typography } from "@mui/material";

function NewStatus(): JSX.Element {
  return (
    <Stack
      sx={{
        py: 5,
        justifyContent: "center",
        alignItems: "center",
      }}
      gap={3}
    >
      <div
        style={{
          width: "48px",
          height: "48px",
          borderRadius: "50%",
          display: "inline-block",
          borderTop: "4px solid #3250ff",
          borderRight: "4px solid transparent",
          boxSizing: "border-box",
          animation: "rotation 1s linear infinite",
          position: "relative",
        }}
      >
        <div
          style={{
            content: "''",
            boxSizing: "border-box",
            position: "absolute",
            left: 0,
            top: 0,
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            borderBottom: "4px solid #000000",
            borderLeft: "4px solid transparent",
          }}
        ></div>
        <style>{`
      @keyframes rotation {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `}</style>
      </div>
      <Box textAlign="center" gap={1}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
          }}
        >
          Processing Your Request
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#555555",
          }}
        >
          Your request is still being processed. Please wait a moment.
        </Typography>
      </Box>
    </Stack>
  );
}

export default NewStatus;
